document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.kr-slide').forEach(slide=>{

      slide.addEventListener('click',(e)=>{

          if(e.target.closest('a')) return;

          const url=slide.dataset.link;

          if(url){
              window.location.href=url;
          }

      });

  });

});